module.exports = __webpack_public_path__ + "static/media/rural-farmlife-australia.6e52770a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/rural-farmlife-australia.jpg
// module id = 147
// module chunks = 0